import React from "react";
import { Link } from "react-router-dom";
import { CONTACT_SUPPORT_PATH } from "../../utils/support";

const SupportLink = ({
  children = "Help / Contact Support",
  className = "support-link",
  to = CONTACT_SUPPORT_PATH,
  ...props
}) => (
  <Link className={className} to={to} {...props}>
    {children}
  </Link>
);

export default SupportLink;
